import * as ngCore from '@angular/core'
import * as ngRouter from '@angular/router'

/**
 * Used when user is not within any particular application in the platform
 *
 * This is usually because the user does not have access to any tenants/zones
 */
@ngCore.Component({
  imports: [ngRouter.RouterLink],
  selector: 'atn-landing-page',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /**
   * Reloads the current page
   */
  public refresh() {
    window.location.reload()
  }
}
